export function fixedDecimal(
  value: number | undefined,
  decimal: number = 2
): string {
  if (typeof value !== "number" || isNaN(value)) {
    value = 0;
  }
  return value.toFixed(decimal);
}
